import { FC, useEffect, useRef } from "react";

import { FaCheck } from "react-icons/fa";
import anime from "animejs";

interface Step {
  title: string;
  content: (ref?: React.RefObject<HTMLSpanElement>) => JSX.Element | string;
}

const steps: Step[] = [
  {
    title: "1º Passo",
    content: (ref) => (
      <>
        <p className="text-xl">Tenha em mãos os dados necessários:</p>
        <ul className="mt-2 text-[#797A7C]">
          <li className="flex items-center gap-2">
            <FaCheck className="text-white bg-[#797A7C] p-1" />
            Placa do veículo (formato sem espaços, ex.: ABC0123 ou ABCD123).
          </li>
          <li className="flex items-center gap-2">
            <FaCheck className="text-white bg-[#797A7C] p-1" />
            <span>
              CPF ou CNPJ do proprietário do veículo (apenas números).
            </span>
          </li>
        </ul>
        <p className="bg-[#fcd34d66] py-6 px-8 font-medium mt-4 relative overflow-hidden">
          <span ref={ref} className="font-bold inline-block origin-center">
            Importante:
          </span>{" "}
          Nosso assistente virtual não aceita áudios ou fotos. Ele é focado
          exclusivamente em ajudá-lo com o agendamento.
        </p>
      </>
    ),
  },
  {
    title: "2º Passo",
    content: () => (
      <>
        <p className="text-xl">Escolha o tipo de serviço que deseja agendar:</p>
        <ul className="mt-2 text-[#797A7C]">
          <li className="flex items-center  gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              1
            </span>
            Agendamento de Serviços
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              2
            </span>
            Agendamento de Recall
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              3
            </span>
            Revalidação de Garantia
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              4
            </span>
            Consulta de Agendamento
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              5
            </span>
            Reagendar Serviço
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              6
            </span>
            Cancelar Agendamento
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              7
            </span>
            Falar com Atendentes
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "3º Passo",
    content: () => (
      <>
        <p className="text-xl">Informe o Estado e a unidade desejada:</p>
        <p className="text-xs">
          Escolha o local mais conveniente para o serviço. Exemplo:
        </p>
        <ul className="mt-2 text-[#797A7C]">
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              1
            </span>
            Espírito Santo
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              2
            </span>
            Brasília
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              3
            </span>
            Minas Gerais
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "4º Passo",
    content: () => (
      <>
        <p className="text-xl">Selecione o tipo de serviço:</p>
        <p className="text-xs">
          Escolha o tipo de serviço que deseja agendar. Exemplo:
        </p>
        <ul className="mt-2 text-[#797A7C]">
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              1
            </span>
            Revisão Periódica
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              2
            </span>
            Revisão de Boas-Vindas
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              3
            </span>
            Alinhamento e Balanceamento
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              4
            </span>
            Diagnóstico
          </li>
          <li className="flex items-center gap-2">
            <span className="w-4 h-4 bg-[#797A7C] flex items-center justify-center text-sm text-white">
              5
            </span>
            Outros Serviços
          </li>
        </ul>
      </>
    ),
  },
  {
    title: "5º Passo",
    content: () => (
      <>
        <p className="text-xl">Escolha a data e o horário disponíveis:</p>
        <p className="text-xs">
          O sistema mostrará as opções disponíveis para sua conveniência.
        </p>
      </>
    ),
  },
  {
    title: "6º Passo",
    content: () => (
      <>
        <p className="text-xl">Confirme as informações:</p>
        <p className="text-xs">
          Após selecionar o local, data, horário e tipo de serviço, você
          receberá um resumo. Basta confirmar para finalizar o agendamento.
        </p>
      </>
    ),
  },
];

const StepByStep: FC = () => {
  const importantTextRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (importantTextRef.current) {
      anime({
        targets: importantTextRef.current,
        rotate: [
          { value: -8, duration: 90 },
          { value: 8, duration: 90 },
          { value: -8, duration: 90 },
          { value: 8, duration: 90 },
          { value: 0, duration: 90 },
        ],
        translateX: [
          { value: -2, duration: 90 },
          { value: 2, duration: 90 },
          { value: -2, duration: 90 },
          { value: 2, duration: 90 },
          { value: 0, duration: 90 },
        ],
        easing: "easeInOutElastic(10, 2)",
        loop: true,
        delay: 1000,
        endDelay: 1000,
        direction: "alternate",
      });
    }
  }, []);

  return (
    <section className="py-12 px-6 bg-[#F2F2F2] text-gray-800">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8">
          Passo a Passo para Realizar o Agendamento
        </h2>

        {/* Grid responsivo - cards empilham no mobile */}
        <div className="grid md:grid-cols-2 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="bg-white shadow-md relative">
              <img
                src={`https://sablobsitestoyotaprd.blob.core.windows.net/images/Agendamento/passo_${
                  index + 1
                }.svg`}
                alt={step.title}
                width={200}
                height={50}
                className=""
              />
              <div className="p-6 mt-8">
                <div className="text-black text-sm">
                  {index === 0
                    ? step.content(importantTextRef)
                    : step.content()}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StepByStep;
